import React from 'react';
// eslint-disable-next-line no-unused-vars
import ModelCheck from '../model/ModelCheck';

const Share = (props) => {
    const isMobile = window.innerWidth < 768
    /** @type {ModelCheck} */
    const check = props.data

    return (
        <div className={ 'share-button'}>
            <button className='clicable' onClick={props.onClickShare}>Share</button>
        </div>
    )
}

export default Share